import React from "react";
import "./adddetailsbydimension.css";
import TextFeild from "../../../CustomTextFeild/TextFeild";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";

const AddDetailsByDimension = ({
  addDetail,
  formulaDetails,
  handleChangeDetails,
  tierFormula,
}) => {
  const { t } = useTranslation(["warehouse", "common"]);
  return (
    <>
      <div className="details_bydimension_formrow">
        <div className="details_bydimension_wrapper">
          <TextFeild
            Name="min_length"
            Label={t("fulfilmentTier.minLength")}
            Required={false}
            Data={formulaDetails?.min_length}
            Disabled={tierFormula?.dimensions?.length === 0}
            Handler={(e) => handleChangeDetails(e)}
          />
          <TextFeild
            Name="min_width"
            Label={t("fulfilmentTier.minWidth")}
            Required={false}
            Data={formulaDetails?.min_width}
            Disabled={tierFormula?.dimensions?.length === 0}
            Handler={(e) => handleChangeDetails(e)}
          />
          <TextFeild
            Name="min_height"
            Label={t("fulfilmentTier.minHeight")}
            Required={false}
            Data={formulaDetails?.min_height}
            Disabled={tierFormula?.dimensions?.length === 0}
            Handler={(e) => handleChangeDetails(e)}
          />
        </div>
        <div className="details_bydimension_wrapper">
          <TextFeild
            Label={t("fulfilmentTier.maxLength")}
            Name="max_length"
            Required={false}
            Data={formulaDetails?.max_length}
            Handler={(e) => handleChangeDetails(e)}
          />
          <TextFeild
            Label={t("fulfilmentTier.maxWidth")}
            Name="max_width"
            Required={false}
            Data={formulaDetails?.max_width}
            Handler={(e) => handleChangeDetails(e)}
          />
          <TextFeild
            Label={t("fulfilmentTier.maxHeight")}
            Name="max_height"
            Required={false}
            Data={formulaDetails?.max_height}
            Handler={(e) => handleChangeDetails(e)}
          />
        </div>

        <button
          className="details_bydimension_modalsave details_bydimension_details"
          onClick={(e) => addDetail(e)}
        >
          <span>{t("common:actions.add")} </span> +
        </button>
      </div>
    </>
  );
};

export default AddDetailsByDimension;
